module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "konfigurator-alergie"
    }
  }, [_c('h1', [_vm._v("Má " + _vm._s(_vm.mazlicek.jmeno.value) + " nějaké zdravotní obtíže?")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isAlergieValid() && this.tryescape),
      expression: "!isAlergieValid() && this.tryescape"
    }],
    staticClass: "info-messages-box"
  }, [(!_vm.isAlergieValid() && this.tryescape) ? _c('div', {
    staticClass: "error-msg"
  }, [_vm._v("\n            Vyberte alespoň jednu z možností\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "konfigurator-alergie"
  }, [_c('div', {
    staticClass: "form-radios"
  }, _vm._l((_vm.alergieItems), function(item) {
    return _c('div', {
      staticClass: "form-type-radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.mazlicek.alergie.alergie),
        expression: "mazlicek.alergie.alergie"
      }],
      attrs: {
        "type": "radio",
        "id": String(item.val) + '-alergie'
      },
      domProps: {
        "value": item.val,
        "checked": _vm._q(_vm.mazlicek.alergie.alergie, item.val)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.mazlicek.alergie, "alergie", item.val)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": String(item.val) + '-alergie'
      }
    }, [_vm._v("\n                        " + _vm._s(item.label) + "\n                    ")])])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mazlicek.alergie.alergie),
      expression: "mazlicek.alergie.alergie"
    }],
    staticClass: "konfigurator-alergie-vypis"
  }, [_c('div', {
    staticClass: "form-type-checkboxes",
    class: {
      'has-error': !_vm.isAlergieValid() && this.tryescape
    }
  }, _vm._l((_vm.alergenyItems), function(item) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.mazlicek.alergie.alergie),
        expression: "mazlicek.alergie.alergie"
      }],
      staticClass: "form-type-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.mazlicek.alergie.alergeny),
        expression: "mazlicek.alergie.alergeny"
      }],
      attrs: {
        "type": "checkbox",
        "id": item.id
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.mazlicek.alergie.alergeny) ? _vm._i(_vm.mazlicek.alergie.alergeny, item.id) > -1 : (_vm.mazlicek.alergie.alergeny)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.mazlicek.alergie.alergeny,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.mazlicek.alergie, "alergeny", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.mazlicek.alergie, "alergeny", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.mazlicek.alergie, "alergeny", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": item.id
      }
    }, [_vm._v("\n                        " + _vm._s(item.title) + "\n                    ")])])
  }), 0)])]), _vm._v(" "), _c('info', {
    attrs: {
      "krok": 8
    }
  }), _vm._v(" "), _c('navigace', {
    attrs: {
      "showPrev": true,
      "onClickPrev": _vm.prev,
      "showNext": true,
      "disableNext": !_vm.valid,
      "onClickNext": _vm.next,
      "onClickSaveAndQuit": _vm.saveAndQuit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-373a644d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/08Alergie.vue
// module id = 568
// module chunks = 1